export default __webpack_public_path__ + "static/media/FOODIE.b505efaf.png";